<div class="flex items-center relative">
    <div class="flex-1 min-w-0">
        <p class="text-sm font-medium text-gray-900 truncate dark:text-white">
            {{name()}} {{lastName()}}
        </p>
        <p class="text-sm text-gray-500 truncate dark:text-gray-400">
            {{email()}}
        </p>
        <p class="text-sm text-gray-500 truncate dark:text-gray-400">
            {{createdAt()| relativeDate:'pt-BR'}}
        </p>
    </div>
    <div class="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white">
        {{roles()?.join(', ')}}

    @if(mutable()){
        <button type="button" (click)="onDelete($event)"
            class="ms-3 bg-blue-700 hover:bg-blue-800 focus:ring-2 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm p-2 text-center inline-flex items-center me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z" />
            </svg>
            <span class="sr-only">Icon description</span>
        </button>
        }
    </div>
</div>